(() => {
  const arrangeTracking = () => {
    const form = document.querySelector('#yq-tracking-form');
    if (!form || document.querySelector('.mirthly-tracking-page-title')) return;
    form.querySelectorAll('button[type="submit"]').forEach(button => {
      const label = button.querySelector('span') || button;
      label.textContent = 'Track';
    });
    const title = form.querySelector('h1');
    if (!title) return;
    title.classList.add('mirthly-tracking-page-title');
    form.before(title);
    const faq = document.createElement('section');
    faq.className = 'mirthly-tracking-faq';
    faq.setAttribute('aria-label', 'Tracking questions');
    faq.innerHTML = `<h2>Frequently Asked Questions</h2>
      <details><summary>Where can I find my tracking number?</summary><p>Your tracking number is in your shipping confirmation email. You can also use your order number and the email address used at checkout.</p></details>
      <details><summary>Why hasn't my tracking updated?</summary><p>A new tracking number may take time to show its first carrier scan. Check again later. If you need help, email <a href="mailto:mirthlyshop@gmail.com">mirthlyshop@gmail.com</a> with your order number.</p></details>
      <details><summary>My package says delivered, but I haven't received it.</summary><p>Check your delivery location and ask anyone who may have accepted the parcel. If you still cannot find it, contact the carrier and our support team.</p></details>
      <details><summary>How do I contact support?</summary><p>Email <a href="mailto:mirthlyshop@gmail.com">mirthlyshop@gmail.com</a> or visit our <a href="/pages/contact">CONTACT</a> page.<br>Monday – Friday: 9 AM – 8 PM<br>Saturday – Sunday: 10 AM – 6 PM</p></details>`;
    form.after(faq);
  };
  arrangeTracking();
  const trackingObserver = new MutationObserver(() => {
    arrangeTracking();
    if (document.querySelector('.mirthly-tracking-faq')) trackingObserver.disconnect();
  });
  trackingObserver.observe(document.body, {childList: true, subtree: true});
  const header = document.querySelector('.mirthly-tracking-shell .header');
  const menu = header?.querySelector('.menu');
  const nav = header?.querySelector('nav');
  const setOpen = open => {
    nav?.classList.toggle('open', open);
    menu?.classList.toggle('open', open);
    menu?.setAttribute('aria-expanded', String(open));
    menu?.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  };
  menu?.addEventListener('click', event => {event.stopPropagation();setOpen(!nav.classList.contains('open'));});
  document.addEventListener('click', event => {if (!header?.contains(event.target)) setOpen(false);});
  document.addEventListener('keydown', event => {if (event.key === 'Escape') setOpen(false);});
})();
